export const UserRole = {
  TRAINER: 't' as const,
  STUDENT: 's' as const,
};

export const UserGender = {
  MALE: 'm' as const,
  FEMALE: 'w' as const,
};
